import type {JSX} from 'react';
import {HamburgerMenuIcon, SearchIcon} from '@prtimes-basis/icons';
import {PrTimesLogo} from '@prtimes-basis/logos/pr-times-logo';
import {clsx} from 'clsx';
import styles from './sp-header.module.css';

export function SpHeader({...props}: JSX.IntrinsicElements['div']) {
  return (
    <div className={styles.container} {...props}>
      <div className={styles.inner}>
        <div className={styles.left}>
          <HamburgerMenuIcon />
          <PrTimesLogo variant='white' className={styles.logo} />
        </div>

        <div className={styles.right}>
          <p className={styles.link}>ログイン</p>
          <p className={clsx(styles.link, styles.linkBorder)}>新規登録</p>
          <SearchIcon variant='white' />
        </div>
      </div>
    </div>
  );
}
